import i18n from '../../i18n.js';

function getValue(order, key) {
  if (order._changes.hasOwnProperty(key)) {
    return order._changes[key];
  }

  return order[key];
}

const validationFunctions = {
  verification_in_available_databases: order => {
    const value = getValue(order, 'verification_in_available_databases');

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  },
  verification_in_other_sources: order => {
    const value = getValue(order, 'verification_in_other_sources');

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  },
  contact_person: order => {
    const value = getValue(order, 'contact_person');

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  },
  phone_number: order => {
    const value = getValue(order, 'phone_number');

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  },
  email_address: order => {
    const value = getValue(order, 'email_address');

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  },
  headquarter_address: order => {
    const value = getValue(order, 'headquarter_address');

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  },
  headquarter_description: order => {
    const value = getValue(order, 'headquarter_description');

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  },
  subject_of_lease_location: order => {
    const value = getValue(order, 'subject_of_lease_location');

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 2) {
      return i18n.global.t('errors.fieldMinLength2');
    }

    return '';
  },
  purpose_and_legitimacy: order => {
    const value = getValue(order, 'purpose_and_legitimacy');

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  },
  financial_support: order => {
    const value = getValue(order, 'financial_support');

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  },
  supplier_connections: order => {
    const value = getValue(order, 'supplier_connections');

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  },
  field_vision: order => {
    const value = getValue(order, 'field_vision');

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  },
  place_of_activity_assessment: order => {
    const value = getValue(order, 'place_of_activity_assessment');

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  },
  subject_of_lease_assessment: order => {
    const value = getValue(order, 'subject_of_lease_assessment');

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  },
  customer_information: order => {
    const value = getValue(order, 'customer_information');

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  },
  notes: order => {
    return '';
  },
  final_opinion: order => {
    const value = getValue(order, 'final_opinion');

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    return '';
  },
  final_opinion_description: order => {
    const value = getValue(order, 'final_opinion_description');

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  },
  final_opinion_confirmation: order => {
    const status = getValue(order, 'status');
    
    if (status !== 'awaiting_acceptance') {
      return true;
    }

    const value = getValue(order, 'final_opinion_confirmation');

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  },
  final_opinion_confirmation_description: order => {
    const status = getValue(order, 'status');
    
    if (status !== 'awaiting_acceptance') {
      return true;
    }

    const value = getValue(order, 'final_opinion_confirmation_description');

    if ((value?.length ?? 0) < 1) {
      return i18n.global.t('errors.fieldCantBeEmpty');
    }

    if ((value?.length ?? 0) < 3) {
      return i18n.global.t('errors.fieldMinLength3');
    }

    return '';
  }
};

function validateSingleField(order, key) {
  return validationFunctions[key](order);
}

function validateAllFields(order) {
  const errors = {};

  Object.keys(validationFunctions).forEach(key => {
    const message = validationFunctions[key](order);

    if (message.length > 0) {
      errors[key] = message;
    }
  });

  return errors;
}

export { validateSingleField, validateAllFields };
